<template>
    <div class="slide-container">
        <div class="section-head">
            <span class="section-title">热门推荐</span>
            <span class="section-note">快捷入口</span>
        </div>
        <div class="icon-grid">
            <article class="icon-item" v-for="item in dataList" :key="item.id">
                <button type="button" class="icon-btn" @click="goDownload(item)">
                    <div class="pic"><img :src="item.pic" alt="" /></div>
                    <div class="title">{{ item.title }}</div>
                    <div class="download-text">下载</div>
                </button>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props: ["dataList"],
    methods: {
        async goDownload(item) {
            if (!item || !item.url) return
            try {
                await this.$http.post('/track_click', {
                    target_type: 'app',
                    target_id: item.id
                })
            } catch (error) {
                // 统计失败不阻断下载跳转
            }
            window.open(item.url, '_blank')
        }
    }
};
</script>

<style lang="less" scoped>
.slide-container {
    margin-top: 1rem;
    padding: .95rem;
    border-radius: var(--a-radius);
    border: 1px solid rgba(34, 211, 238, .16);
    box-shadow: var(--a-shadow);
    background: linear-gradient(145deg, rgba(15, 23, 42, 0.95), rgba(9, 14, 34, 0.92));
}

.section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .8rem;
}

.section-title {
    color: #f8fafc;
    font-size: 1.05rem;
    font-weight: 800;
}

.section-note {
    color: #22d3ee;
    font-weight: 700;
    font-size: .8rem;
}

.icon-grid {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem;
}

.icon-item {
    width: calc((100% - 1.75rem) / 6);
    flex: 0 0 calc((100% - 1.75rem) / 6);
    min-width: 0;
}

.icon-btn {
    width: 100%;
    border: 0;
    background: transparent;
    padding: 0;
    .pic {
        width: 100%;
        aspect-ratio: 1 / 1;
        max-height: 4.8rem;
        border-radius: .55rem;
        overflow: hidden;
        background: rgba(255,255,255,.04);
        border: 1px solid rgba(139, 92, 246, .18);
        box-shadow: 0 8px 16px rgba(2, 6, 23, .2);
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
        }
    }
}

.title {
    color: #e2e8f0;
    font-size: .76rem;
    font-weight: 700;
    line-height: 1.2;
    margin-top: .22rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.download-text {
    color: #22d3ee;
    font-size: .72rem;
    font-weight: 800;
    text-align: center;
    margin-top: .12rem;
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    border: 1px solid rgba(34, 211, 238, .3);
    border-radius: .28rem;
    background: rgba(34, 211, 238, .08);
    box-sizing: border-box;
}

@media screen and (max-width: 360px) {
    .icon-item {
        width: calc((100% - 1.4rem) / 5);
        flex: 0 0 calc((100% - 1.4rem) / 5);
    }
}
</style>